  <div class="custom-theme-modal modal-dialog modal-md modal-dialog-scrollable">
    <div class="modal-content  " *ngIf="speakerData == ''">
      <div class="modal-header d-block px-4 pt-4">
        <div class="">
          <div class="row">
            <div class="col-6">
              <p class="heading-4">
                <span class="color-grey-700">{{ mls.languageText.speaker_list.key1 }}</span>
              </p>
            </div>
            <div class="col-6 text-right">
              <span class="cursor-pointer" (click)="goback()">
                  <img src="assets/themes/icons/cancel.svg" alt="cross">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <!-- list -->
        <div
          class="border-bottom last-item-border"
          *ngFor="let speakerObj of data.data"
        >
          <!-- {{speakerObj |json}} -->
          <app-speaker-card  
            [callingfrom]="callingfrom"
            [speakerObj]="speakerObj"
            (click)="speakerDetail(speakerObj)"
          ></app-speaker-card>
        </div>
        <!-- list -->
      </div>
    </div>

    <div class="modal-content paragraph" *ngIf="speakerData != ''">
      <div class="modal-header d-block p-0">
        <div class="">
          <div class="row">
            <div class="col-12">
              <p  class="heading-4 p-4">
                <img (click)="backtolist()" class=" cursor-pointer" src="assets/themes/icons/backarrow.svg" alt="back">
                {{ mls.languageText.speaker_list.key2 }}
                <span class="float-right ">
                  <img (click)="goback()" class=" cursor-pointer" src="assets/themes/icons/cancel.svg" alt="">
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="clearfix mb-4 row">
          <div class="position-relative clnder-main-img col-3 pr-0">
            <img
              (click)="open($event.target.src)"
              class="b-radius  post-pic-bg rnded-circle clnder-main-img  float-left cursor-pointer"
              [src]="speakerData?.profile_pic"
              onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'"/>
          </div>

          <div class="col-9">
            <p class="heading-3">
              {{ speakerData?.name }}
            </p>
            <p
              class="pt-1 paragraph"
              *ngIf="speakerData?.speciality_name != ''"
            >
              <span class="color-grey-500"> {{ speakerData?.speciality_name }}</span>
            </p>
            <p
              class="secondary-paragraph"
              *ngIf="speakerData?.qualification != ''"
            >
              <span class="color-grey-500">{{ speakerData?.qualification }}</span>
            </p>
          </div>
        </div>

        <div class="pt-2 pb-3 border-color" *ngIf="speakerData?.synopsis != ''">
          <p class="paragraph-bold mb-2">
            <span class="color-grey-700"> {{ mls.languageText.speaker_list.key3 }}</span>
          </p>
          <span class="secondary-paragraph link-text">
            <span class="color-grey-700" innerHtml="{{ speakerData?.synopsis | linkify }}"></span>
          </span>
        </div>
        <div
          class="py-2 border-color"
          *ngIf="
            speakerData?.speaker_doc != undefined &&
            speakerData?.speaker_doc != ''">
          <p class="paragraph-bold mb-2">
            <span class="color-grey-700">{{ mls.languageText.speaker_list.key4 }}</span>
          </p>
          <!-- list --> 
          <div (click)="viewCertificate()"
            class="clearfix pb-2 pt-2 position-relative cursor-pointer">
            <div class="row">   
              <div *ngIf="speakerData?.speaker_doc.indexOf('pdf') > -1"
                class="col-md-3 col-3">
                <div class="overflow-hidden b-radius height-60" >
                  <app-pdf-view  
                    [pdfscr]="speakerData?.speaker_doc"
                    [idx]="0"
                    [useractivity]="0"
                  ></app-pdf-view>
                </div>
              </div>
              <div  *ngIf="speakerData?.speaker_doc.indexOf('jpg') > -1"
                class="col-md-3 col-3">
                <div class="overflow-hidden img-radius  height-60" >  
                  <img src="{{ speakerData?.speaker_doc }}"
                    onerror="this.src='assets/themes/icons/banner-placeholder.svg'" />
                </div>
              </div>

              <div class="col-md-9 pl-0 col-9">
                <div class="d-table w-100 table-lyout">
                  <div class="d-table-cell secondary-paragraph align-middle pr-4">
                    <span class="color-grey-700">{{ speaker_docq }}</span>
                  </div>
                </div>
              </div>
            </div>
             <span  class="position-absolute arrow-position">
            <img src="assets/themes/icons/right-arrow.svg" width="16px" height="16px" alt="right-arrow" />
            </span>  
          </div>
        </div>
      </div>
    </div>

    <app-media-modal  
      *ngIf="mediaModal == true && openMediaIndex != undefined"
      (resetMediaModal)="setResetMediaModal($event)"
      [isMediaModalShown]="mediaModal"
      [mediaObj]="mediaObj"
      [openMediaIndex]="openMediaIndex"
    ></app-media-modal>
  </div>